var CustomTooltipRendererComponent = /** @class */ (function () {
    function CustomTooltipRendererComponent() {
    }
    CustomTooltipRendererComponent.prototype.agInit = function (params) {
        this.params = params;
    };
    return CustomTooltipRendererComponent;
}());
export { CustomTooltipRendererComponent };
